import { useSelector, shallowEqual } from 'react-redux';

import {
  selectElectricityRegisters,
  selectGasRegisters
} from 'state/move-in-date/move-in-date-slice';
import {
  selectMeterReads,
  selectRegisters as selectValidatedRegisters
} from 'state/meter-reads/move-in-meter-read-slice';
import { FUEL_TYPES } from 'config/app-config';
import {
  selectElectricityMeterPointId,
  selectGasMeterPointId
} from 'state/move-in-date/move-in-date-slice';

export const useRegistersPayload = ({ fuelType }) => {
  const meterReads = useSelector(selectMeterReads, shallowEqual);
  const validatedRegisters =
    useSelector(selectValidatedRegisters, shallowEqual) || [];
  const electricityRegisters = useSelector(
    selectElectricityRegisters,
    shallowEqual
  );
  const electricityMeterPointId = useSelector(
    selectElectricityMeterPointId,
    shallowEqual
  );
  const gasMeterPointId = useSelector(selectGasMeterPointId, shallowEqual);
  const gasRegisters = useSelector(selectGasRegisters, shallowEqual);
  const validatedRegistersObj = validatedRegisters?.reduce(
    (acc, { registerId, valid }) => {
      return {
        ...acc,
        [registerId]: valid
      };
    },
    {}
  );
  const fuelRegisters =
    fuelType === FUEL_TYPES.ELECTRIC ? electricityRegisters : gasRegisters;
  const meterPointId =
    fuelType === FUEL_TYPES.ELECTRIC
      ? electricityMeterPointId
      : gasMeterPointId;

  const registers = fuelRegisters?.reduce((acc, register) => {
    const { id, period } = register;
    const isValidReadValue = validatedRegistersObj[id];
    const readValue = parseInt(meterReads[id], 10);
    const hasValue = !!readValue;
    const shouldAddToPayload = !!(hasValue && isValidReadValue);

    return [
      ...acc,
      ...(shouldAddToPayload
        ? [
            {
              id,
              meterRead: readValue,
              period
            }
          ]
        : [])
    ];
  }, []);
  const hasRegisters = !!registers?.length;

  return hasRegisters ? { meterPointId, registers } : {};
};
